export const environment = {
  production: false,
  API_URL: 'https://api-dev.powerbihar.com',
  // API_URL: 'http://localhost:8080',
  // API_URL: 'https://3.72.104.205:8080',
};
